import GenericSkeleton from 'components/skeleton/GenericSkeleton';
import { useIsMobile } from 'hooks/ui/useIsMobile';
import { ReactNode } from 'react';
import styles from './DashboardComponentHeader.module.css';

interface Props {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  banner?: ReactNode;
  separator?: boolean;
  loading?: boolean;
  inverseSkeletonColors?: boolean;
}

const DashboardComponentHeader = ({
  title,
  subtitle,
  banner,
  separator,
  loading,
  inverseSkeletonColors,
}: Props) => {
  const { isMobile } = useIsMobile();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <h2 className="aboutUsTypographyHeaderMedium textAlignLeft">
            {loading ? (
              <GenericSkeleton
                inverseColors={inverseSkeletonColors}
                width={isMobile ? 120 : 250}
                height={isMobile ? 24 : 32}
                borderRadius={isMobile ? 12 : 18}
              />
            ) : (
              title
            )}
          </h2>
          {banner}
        </div>
        {subtitle && loading ? (
          <GenericSkeleton
            inverseColors={inverseSkeletonColors}
            width={250}
            height={isMobile ? 18 : 24}
            borderRadius={isMobile ? 12 : 18}
          />
        ) : (
          subtitle && <p className="noMargin">{subtitle}</p>
        )}
      </div>
      {separator && <div className={styles.separator} />}
    </div>
  );
};

export default DashboardComponentHeader;
